import { render, staticRenderFns } from "./VendorsMap.vue?vue&type=template&id=a99ecc90&scoped=true&"
import script from "./VendorsMap.vue?vue&type=script&lang=js&"
export * from "./VendorsMap.vue?vue&type=script&lang=js&"
import style0 from "./VendorsMap.vue?vue&type=style&index=0&id=a99ecc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99ecc90",
  null
  
)

export default component.exports